export default {
  sm: 'py-1 px-2 text-xs',
  base: 'py-3 px-4 text-base',
  lg: 'py-3 px-4 text-base',
  xl: 'py-3 md:py-4 px-4 md:px-6 text-base md:text-lg',
  '2xl': 'py-4 md:py-6 px-8 text-lg md:text-xl font-normal',
};
